import {Container, Row, Col} from 'react-bootstrap';
import {useLanguageContext, useThemeContext} from '../../../context';
import List from './List';
import NonIdealScreen from '../NonIdeal';
import {useNavigate} from 'react-router-dom';
import {PosAppModal} from '../V2';
import SearchBox from '../SearchBox';
import {useSearch} from '../../../hooks';
import {useState} from 'react';
import usePermission from '../../../hooks/usePermission';

const LocationModal = ({toggle, setToggle, locations, selectedLocations, setSelectedLocations, singleSelection}) => {
    const navigate = useNavigate();
    const {I18n} = useLanguageContext();
    const {theme} = useThemeContext();
    const {text, setText, searchList} = useSearch(handleSearch);
    const userPermission = usePermission('location');

    const handleClose = event => {
        setToggle(false);
        setSelectedLocations({});
    };

    const handleCreateLocation = () => {
        navigate('/locations/create');
    };

    const onChange = (event, key) => {
        let value = key || event?.target?.value || '';

        setText(value);
    };

    function handleSearch(val) {
        return locations?.filter(x => x?.name?.toLowerCase().includes(val?.toLowerCase()));
    }

    const handleSave = () => {
        setToggle(false);
    };

    return (
        <PosAppModal
            className="selectCustomerModal"
            toggle={toggle}
            backCta={{
                name: 'backArrowIcon',
                fill: theme.barclaysBlue,
                width: '18',
                height: '18',
                viewBox: '0 0 18 18',
            }}
            handleClose={handleClose}
            bottomSaveCta={{
                title: I18n.save,
                action: () => handleSave(),
            }}
            bottomCancelCta={{
                title: I18n.cancel,
                action: () => handleClose(),
            }}
            rightCta={
                locations?.length && {
                    title: 'Location',
                    action: handleCreateLocation,
                    iconName: 'add2Icon',
                    fill: theme.barclaysBlue,
                    width: '18',
                    height: '18',
                    viewBox: '0 0 18 18',
                }
            }
            title={I18n.location}>
            <>
                {!locations?.length == 0 && (
                    <SearchBox
                        type="pos"
                        placeholder={'Search location by name'}
                        prefix={{
                            name: 'search2Icon',
                            fill: theme.white,
                        }}
                        onChange={onChange}
                    />
                )}

                <Container fluid>
                    <Row className="justify-content-md-center">
                        <Col md={12}>
                            {locations?.length ? (
                                <section className="addScreenMainBox">
                                    <Container>
                                        <Row className="justify-content-md-center">
                                            <Col md={12}>
                                                {(text ? searchList : locations).map((val, index) => (
                                                    <List
                                                        key={index}
                                                        location={val}
                                                        selectedLocations={selectedLocations}
                                                        setSelectedLocations={setSelectedLocations}
                                                        locations={locations}
                                                        singleSelect={singleSelection}
                                                    />
                                                ))}
                                            </Col>
                                        </Row>
                                    </Container>
                                </section>
                            ) : (
                                <NonIdealScreen
                                    heading={I18n.location}
                                    subHeading={I18n.create_location}
                                    name="discountIcon"
                                    fill={theme.white}
                                    primaryCta={
                                        userPermission?.canCrud
                                            ? {
                                                  title: I18n.create_location,
                                                  action: handleCreateLocation,
                                              }
                                            : null
                                    }
                                    isMultiStep={false}
                                />
                            )}
                        </Col>
                    </Row>
                </Container>
            </>
        </PosAppModal>
    );
};

export default LocationModal;
